/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as goalActions from '../../../actions/goalActions'
import ImageUploader from '../../common/form/ImageUploader'
import NewGoalTask from '../../profile/Goals/NewGoalTask'
import moment from 'moment'
import Loader from 'react-loaders'
import PropTypes from 'prop-types'
import { getActiveCommunityId } from '../../../utility/activeCommunity'

class GoalForm extends Component {
  state = {
    creatorId: this.props.user && this.props.user.id,
    userId: this.props.user && this.props.user.id,
    goalName: '',
    goalVideo: '',
    goalDescription: '',
    goalSubjectId: 0,
    goalTaskArray: [0],
    goalTasks: [],
    goalLoader: false,
    submitClicked: false,
    goalCompletion: 0,
    goalImage: '',
    uploadPhotoFileSrc: '',
    uploadPhotoName: '',
    uploadPhotoFile: '',
    didUploadPhoto: false,
    uploadingPhoto: false,
    uploadPhotoFileSources: [],
    pictures: [],
    is_template: false,
    activityDate: moment().format(),
  }

  submitGoal = () => {
    const goalTasks = [...this.state.goalTasks]
    const { closeModal, goal_actions, fetchGoals } = this.props
    this.setState(
      {
        goalLoader: true,
        is_template: true,
      },
      () => {
        goal_actions.createGoal(this.state, goalTasks, getActiveCommunityId(this.props.user)).then(() => {
          this.setState({ goalLoader: false })
          fetchGoals()
          closeModal()
        })
      }
    )
  }
  createGoalTask = () => {
    const taskArray = [...this.state.goalTaskArray]
    const lastNum = taskArray[taskArray.length - 1]

    const newNum = lastNum + 1

    taskArray.push(newNum)

    this.setState({
      goalTaskArray: taskArray,
    })
  }

  deleteGoalTask = () => {
    const taskArray = [...this.state.goalTaskArray]
    const goalArray = [...this.state.goalTasks]
    taskArray.splice(-1, 1)
    goalArray.splice(-1, 1)
    this.setState({
      goalTaskArray: taskArray,
      goalTasks: goalArray,
    })
  }

  onObjectChange = (index, desc, progress, id) => {
    const goalTasks = [...this.state.goalTasks]

    goalTasks[index] = [progress, desc, id]
    this.setState(
      {
        goalTasks: goalTasks,
      },
      () => {
        const percentages = [0]
        let total = 0

        this.state.goalTasks.map(task => {
          percentages.push(task[0])
        })

        total = percentages.reduce((acc, val) => acc + val)
        this.setState({
          goalCompletion: total,
        })
      }
    )
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  selectInputFile() {
    document.getElementById('input-photo-upload').click()
  }

  handlePictureChange = event => {
    if (event.target.files.length > 0) {
      const selectedFiles = event.target.files
      const { pictures } = this.state

      for (let i = 0; i < selectedFiles.length; i++) {
        pictures.push(selectedFiles.item(i))
      }
      this.setState({
        pictures: pictures,
      })
    }
  }

  resetPictures = () => {
    this.setState({
      pictures: [],
    })
  }

  displayImageSelect() {
    const { t } = this.props
    if (this.state.uploadingPhoto) {
      return (
        <div id='GoalImage' className='text-center uploading-images-container'>
          <i
            className='fa fa-circle-o-notch fa-spin fa-lg fa-3x uploading-images-icon'
            aria-hidden='true'
          />
          <p className='mt-2 uploading-images-text'>{t('curriculums.goalForm.uploadingImages')}</p>
        </div>
      )
    } else {
      return (
        <ImageUploader
          label={t('curriculums.goalForm.imageUploadLabel')}
          reset={this.resetPictures}
          id='input-photo-upload'
          onChange={this.handlePictureChange}
          accept={'image/*'}
          selectImages={this.selectInputFile}
          images={this.state.pictures}
          imageSources={this.state.uploadPhotoFileSources}
        />
      )
    }
  }

  renderPercentageText = () => {
    const { t } = this.props
    if (this.state.goalCompletion < 100) {
      return t('curriculums.goalForm.percentageInstruction')
    } else if (this.state.goalCompletion === 100) {
      return t('curriculums.goalForm.percentageComplete')
    } else if (this.state.goalCompletion > 100) {
      return t('curriculums.goalForm.percentageOver')
    }
  }

  renderGoalTasks = () => {
    const lastTaskIndex = this.state.goalTaskArray.lastIndexOf(
      this.state.goalTaskArray[this.state.goalTaskArray.length - 1]
    )
    return this.state.goalTaskArray.map((task, index) => (
      <NewGoalTask
        sendData={getData => {
          this.getData = getData
        }}
        key={index}
        index={index}
        onObjectChange={this.onObjectChange}
        lastIndex={lastTaskIndex}
      />
    ))
  }

  render() {
    const {
      goalName,
      goalVideo,
      goalDescription,
      goalCompletion,
      goalTaskArray,
      goalLoader,
    } = this.state
    const { closeModal, t } = this.props
    return (
      <div>
        {goalLoader ? (
          <Loader message={t('curriculums.goalForm.savingGoal')} />
        ) : (
          <div className='row d-flex align-items-center flex-column h-100 mt-5'>
            <div className='col-md-8 mx-auto'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='col-md-12'>
                    <div className='form-group'>
                      <label htmlFor='program-activity-title'>{t('common.field.name')}</label>
                      <input
                        type='text'
                        name='goalName'
                        className='form-control'
                        id='goal-name'
                        placeholder={t('curriculums.goalForm.namePlaceholder')}
                        onChange={this.handleInputChange}
                        value={goalName}
                      />
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <div className='form-group'>
                      <label htmlFor='program-activity-title'>
                        {t('curriculums.goalForm.videoLabel')}
                      </label>
                      <input
                        type='text'
                        name='goalVideo'
                        className='form-control'
                        id='goal-video'
                        placeholder={t('curriculums.goalForm.videoPlaceholder')}
                        onChange={this.handleInputChange}
                        value={goalVideo}
                      />
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <div className='form-group'>
                      <label htmlFor='goalDescription'>{t('common.field.description')}</label>
                      <textarea
                        type='text'
                        rows={3}
                        name='goalDescription'
                        className='form-control '
                        placeholder={t('curriculums.goalForm.descriptionPlaceholder')}
                        value={goalDescription}
                        onChange={this.handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='my-2 pl-2'>
                    <label className='mt-3 my-0' htmlFor='goal-image'>
                      {t('curriculums.goalForm.imageUploadHeading')}
                    </label>
                  </div>
                  {this.displayImageSelect()}
                </div>
                <div className='col-md-12 goal-objective-percentage-wrapper'>
                  <label htmlFor='goalObjectives'>{t('curriculums.goalForm.objectivesLabel')}</label>
                  <div className='goal-percentage-wrapper hidden-sm-down'>
                    <p className='goal-percentage-desc'>
                      {this.renderPercentageText()}
                    </p>
                    <div
                      className='goal-percentage-tracker'
                      style={{
                        backgroundColor: goalCompletion === 100 ? '#33d9b2' : '',
                      }}
                    >
                      {t('curriculums.goalForm.goalCompletion', { percentage: goalCompletion })}
                    </div>
                  </div>
                </div>
                {this.renderGoalTasks()}
                <div className='col-md-12 goal-objective-border' />
                <div className='col-md-12 goal-objective-icon-wrapper'>
                  {goalTaskArray.length > 1 ? (
                    <i
                      className='fa fa-minus goal-objective-minus-icon'
                      onClick={this.deleteGoalTask}
                    />
                  ) : null}
                  <i
                    className='fa fa-plus goal-objective-add-icon'
                    onClick={this.createGoalTask}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className='row bg-white pb-3'>
          <div className='col-6 mx-auto'>
            <div className='d-flex justify-content-center align-content-center'>
              <button
                className='btn btn-dark log-actions-button m-2'
                onClick={closeModal}
                disabled={goalLoader}
              >
                {t('common.cancel')}
              </button>
              <button
                className='btn btn-primary text-center log-actions-button m-2'
                onClick={this.submitGoal}
                disabled={goalLoader}
              >
                {t(goalLoader ? 'curriculums.goalForm.addingGoal' : 'curriculums.goalForm.addGoal')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, _ownProps) {
  return {
    ui: state.ui,
    user: state.user.current_user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goal_actions: bindActionCreators(goalActions, dispatch),
  }
}

GoalForm.propTypes = {
  user: PropTypes.shape({
    communities: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  }),
  goal_actions: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(GoalForm))
